import { windowWidth, windowHeight, randomNumber } from "../util/helpers.js"

const menuWidthGap = 0.17,
  mediumUpBreakPoint = window.matchMedia("(min-width: 740px)")

function generateImageHovers(element) {
  const menuItems = document.querySelectorAll(element)

  menuItems.forEach(function (index) {
    let image = index.querySelector(".js-list-item__image")
    if (image) {
      index.querySelector(".js-list-item__link").onmouseover = function () {
        imageHover(image)
      }
      index.querySelector(".js-list-item__link").onmouseout = function () {
        imageHoverOut(image)
      }
    }
  })

  /**
   * Safari cache fix to remove onmouseover images
   */
  function resetImageOpacity() {
    menuItems.forEach(function (index) {
      let image = index.querySelector(".js-list-item__image")
      if (image) {
        image.style.opacity = "0"
      }
    })
  }

  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      resetImageOpacity()
    }
  })
}

function imageHover(image) {
  let imageWidth = image.offsetWidth,
    imageHeight = image.offsetWidth,
    randomPositionLeft = windowWidth - imageWidth,
    randomPositionTop = windowHeight - imageHeight,
    positionLeft = randomNumber(windowWidth * menuWidthGap, randomPositionLeft),
    positionTop = randomNumber(0, randomPositionTop)

  image.style.opacity = "1"
  image.style.left = positionLeft + "px"
  image.style.top = positionTop + "px"
}

function imageHoverOut(image) {
  image.style.opacity = "0"
}

if (document.body.classList.contains("page-template-template-participants")) {
  if (mediumUpBreakPoint.matches) {
    generateImageHovers(".js-link-item")
  }
}
